import { render, staticRenderFns } from "./CoinSelectBoxUsd.vue?vue&type=template&id=8ac88958&scoped=true"
import script from "./CoinSelectBoxUsd.vue?vue&type=script&lang=js"
export * from "./CoinSelectBoxUsd.vue?vue&type=script&lang=js"
import style0 from "./CoinSelectBoxUsd.vue?vue&type=style&index=0&id=8ac88958&prod&lang=scss&scoped=true"
import style1 from "./CoinSelectBoxUsd.vue?vue&type=style&index=1&id=8ac88958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac88958",
  null
  
)

export default component.exports